@if (!data && isLoading) {
	<ui-spinner size="m" [inverted]="inverted"></ui-spinner>
}
@if (isLoading && data && data.length === 0) {
	<div class="spinner">
		@if (!small) {
			<ui-empty-state
				[isAbsolute]="true"
				[text]="(isMachineSelected ? 'general.no_data' : 'general.no_machines') | translate"
				[buttonText]="
					!noLink
						? ((isMachineSelected ? 'general.change_date' : 'general.change_machines') | translate)
						: ''
				"
				(buttonClicked)="isMachineSelected ? openDateSelector($event) : openMachineSelector($event)"
			>
			</ui-empty-state>
		}
	</div>
}
